import React, { useContext } from 'react';

// import { Loader, Wapper } from './styles';
import { ThemeContext } from 'styled-components';
import { Oval, ThreeDots } from 'react-loader-spinner';
import { darken } from 'polished';

// import { LoaderProps } from 'react-loader-spinner';

interface SpinnerProps {
  height?: number;
  width?: number;
  align?: 'center' | 'flex-end' | 'flex-start';
  type?: string;
  margin?: string;
}

// other logic
const Spinner: React.FC<SpinnerProps> = ({
  width = 30,
  height = 30,
  type = 'Oval',
}: SpinnerProps) => {
  const themeContext = useContext(ThemeContext);
  switch (type) {
    case 'ThreeDots':
      return (
        <ThreeDots color={themeContext?.info} width={width} />
        // <Wapper $align={align} $margin={margin}>
        //   <Loader
        //     type={type}
        //     color={themeContext?.info}
        //     height={height}
        //     width={width}
        //   />
        // </Wapper>
      );
    default:
      return (
        <Oval
          color={themeContext?.info}
          secondaryColor={
            themeContext ? darken(0.01, themeContext.info) : undefined
          }
          width={width}
          height={height}
        />
        // <Wapper $align={align} $margin={margin}>
        //   <Loader
        //     type={type}
        //     color={themeContext?.info}
        //     height={height}
        //     width={width}
        //   />
        // </Wapper>
      );
  }
};

export default Spinner;
